<template>
  <div
    v-bind="attributeId"
    class="eds-toolbar"
    :class="[
      {
        'toolbar-inverse': isInverse,
      },
      className,
    ]"
    :style="style"
  >
    <div
      class="toolbar-section no-padding"
      :class="filterClass"
      :style="filterStyle"
    >
      <Textbox
        v-model="filterValue"
        v-if="filterable"
        field-control-class="input-no-border"
        placeholder="Type here to filter..."
        @update:modelValue="filterOptionsHandler"
      />
    </div>
    <slot name="toolbarSection" />
  </div>
</template>

<script lang="ts" setup>
  import { useAttrs, computed, ref, toRefs, StyleValue } from 'vue';
  import Textbox from '@atb-ui/eds-vue/src/components/Textbox.vue';

  interface ToolbarProps {
    filterable?: boolean;
    isInverse?: boolean;
    className?: string;
    style?: StyleValue;
    filterClass?: string;
    filterStyle?: StyleValue;
  }

  const props = withDefaults(defineProps<ToolbarProps>(), {
    filterable: false,
    isInverse: false,
    className: '',
    filterClass: '',
  });

  const { filterable, isInverse, className, style, filterClass, filterStyle } =
    toRefs(props);

  const attributeId = computed(() => {
    const attrs = useAttrs();
    return typeof attrs.id === 'object' ? attrs.id : {};
  });

  const filterOptionsHandler = () => {};
  const filterValue = ref('');
</script>
